import { defineStore } from 'pinia';

export const useLocaleStore = defineStore('locale', {
  persist: true,
  state: () => ({
    locale: undefined
  }),
  actions: {
    setLocale(locale) {
      this.locale = locale;
    },
  }
})
